import { Clock, DollarSign, Target, Users } from "lucide-react";

export const JOB_OPENINGS = [
  {
    id: "lead-generation-specialist",
    title: "Lead Generation Specialist",
    department: "Sales & Growth",
    type: "Full-Time / Flexible Remote",
    experience: "6 Months – 1 Year",
    postedDate: "October 9, 2021",
    location: "Remote / Hybrid (Global Markets Focus)",
    summary:
      "We are looking for a dedicated and honest Lead Generation Specialist to drive targeted cold email campaigns, research industry prospects, and deliver 25 qualified monthly enterprise leads across North America, Europe, Middle East, and APAC.",
    payoutNote: "Payout structures and performance incentives are discussed directly during the introduction call.",
    highlights: [
      {
        icon: Target,
        label: "Monthly Quota",
        value: "25 Qualified Leads / Month",
      },
      {
        icon: Clock,
        label: "Work Flexibility",
        value: "No rigid shift hours; target-driven",
      },
      {
        icon: DollarSign,
        label: "Compensation",
        value: "Base Target + Overachieve Bonus + Closure Cut",
      },
      {
        icon: Users,
        label: "Core Geographies",
        value: "North America, Europe, Middle East & APAC",
      },
    ],
    responsibilities: [
      "Generate verified B2B leads by crafting and sending targeted cold email sequences.",
      "Target accounts across Technology Users, Healthcare, Marketing & Advertising, Construction, Real Estate, and other global sectors.",
      "Develop customized email pitches, tailored hooks, and value-driven outreach copy.",
      "Consistently deliver 25 high-quality, sales-qualified leads each calendar month.",
      "Work independently with minimal supervision while maintaining high pipeline hygiene.",
    ],
    qualifications: [
      "Minimum 6 months to 1 year of core hands-on experience in B2B lead generation via email.",
      "Demonstrated ability to prepare compelling, customized outreach pitches.",
      "Familiarity with prospect research, B2B databases, and deliverability best practices.",
      "Self-motivated, honest, and hardworking attitude focused on target attainment.",
    ],
    perks: [
      "Flexible schedule without rigid time clocks—outcome and quota focused.",
      "Tiered commission model: extra compensation for over-achievement plus deal closure bonuses.",
      "Full enablement and internal database tooling support provided as needed.",
      "Direct mentorship and high-growth potential within Conectify Tech.",
    ],
    contactPerson: "Talent Acquisition Team",
    contactEmail: "info@Conectifytech.com",
  },
];